import React from 'react'

import './quemconfia.css'
import logos from '../../assets/logos'

const QuemConfia = () => {
  return (
    <div className='lsk__quemconfia'>
        <div className='lsk__quemconfia-title'>
            <h1>Quem Confia</h1>
        </div>
        <div className='lsk__quemconfia-corpo'>
          <span><img src={ logos.algartech } alt='algartech' /></span>
          <span><img src={ logos.yorkdigital } alt='yorkdigital' /></span>
          <span><img src={ logos.sankhya } alt='sankhya' id='sankhya'/></span>
          <span><img src={ logos.callink } alt='callink' /></span>
          <span><img src={ logos.expocaccer } alt='expocaccer' id='expocaccer' /></span>
          <span><img src={ logos.carrodeboi } alt='carrodeboi' /></span>
        </div>
    </div>
  )
}

export default QuemConfia